import { render, staticRenderFns } from "./ListDesserts.vue?vue&type=template&id=6c47a6f2&"
import script from "./ListDesserts.vue?vue&type=script&lang=js&"
export * from "./ListDesserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports